const authFnAllowAdminImplementationManagerOrSASupervisor = userAccess =>
  userAccess.isAdminImplementationManager() || userAccess.isSASupervisor();

export default authFnAllowAdminImplementationManagerOrSASupervisor;
